export default "__VITE_ASSET__4uIWpehq__"